import React, { useEffect, useRef, useState } from 'react';
import api from '../api';
import { cargarPayphoneScript } from '../payphoneLoader';

/**
 * Cajita de Pagos de Payphone embebida — paga el "total_pagar_ahora" de una
 * solicitud de compra asistida sin salir de la app. Al confirmar, Payphone
 * redirige el navegador a responseUrl con ?id=&clientTransactionId=; la
 * confirmación real (server-side, dentro de 5 min) la hace ClientePanel al
 * detectar esos parámetros al volver a cargar.
 */
export default function PagoPayphoneCompraAsistida({ solicitud }) {
  const contenedorId = `payphone-box-${solicitud.id}`;
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const montado = useRef(false);

  useEffect(() => {
    if (montado.current) return;
    montado.current = true;
    let cancelado = false;

    api.get('/compra-asistida/config-pago/')
      .then(async (res) => {
        const { payphone_token, payphone_store_id } = res.data;
        if (!payphone_token) {
          setError('El pago con tarjeta todavía no está disponible. Usa transferencia bancaria por ahora.');
          return;
        }
        await cargarPayphoneScript();
        if (cancelado) return;

        const clientTransactionId = `compra-${solicitud.id}-${Date.now()}`;
        const montoCentavos = Math.round(Number(solicitud.total_pagar_ahora) * 100);

        const config = {
          token: payphone_token,
          clientTransactionId,
          amount: montoCentavos,
          amountWithoutTax: montoCentavos,
          amountWithTax: 0,
          tax: 0,
          service: 0,
          tip: 0,
          currency: 'USD',
          reference: `Compra asistida Ecuafly #${solicitud.id}`,
          // Debe coincidir con la "Url de respuesta" registrada en el panel de
          // Payphone Developer para esta app. SIN query string propio: Payphone
          // le pega su "?id=&clientTransactionId=" a esta URL sin revisar si ya
          // tenía un "?" — con uno propio queda una URL con DOS "?" que rompe la
          // lectura de parámetros (bug real, encontrado en el primer pago de
          // prueba). El id de la solicitud viaja adentro del clientTransactionId
          // en su lugar (`compra-<id>-<timestamp>`), que ClientePanel parsea.
          responseUrl: `${window.location.origin}/pagos/payphone/respuesta`,
          email: solicitud.email,
          lang: 'es',
        };
        if (payphone_store_id) config.storeId = payphone_store_id;

        // eslint-disable-next-line no-undef
        new window.PPaymentButtonBox(config).render(contenedorId);
      })
      .catch(() => setError('No se pudo cargar el pago con tarjeta. Usa transferencia bancaria por ahora.'))
      .finally(() => { if (!cancelado) setCargando(false); });

    return () => { cancelado = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return <p className="text-sm text-secondary" style={{ marginTop: 'var(--spacing-2)' }}>{error}</p>;
  }

  return (
    <div style={{ marginTop: 'var(--spacing-2)', minWidth: 0 }}>
      {cargando && <p className="text-sm text-secondary">Cargando pago con tarjeta...</p>}
      {/* overflowX + minWidth:0 — la Cajita puede pedir más ancho del que
          tiene la tarjeta; que se desplace ella sola en vez de forzar el
          ancho de toda la página (causaba el "resize" en móvil y PC). */}
      <div id={contenedorId} style={{ overflowX: 'auto', minWidth: 0 }} />
    </div>
  );
}
